module.exports = __webpack_public_path__ + "static/media/faq.d8f5ec19.jpg";